export const badgeObject = {
    // tags
    string: {
        type: "STR",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    date: {
        type: "DATE",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    time: {
        type: "TIME",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    datetime: {
        type: "DTM",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    dtm: {
        type: "DTM",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    integer: {
        type: "INT",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    boolean: {
        type: "BOOL",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    decimal: {
        type: "DEC",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    attribute: {
        type: "ATT",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    attachment: {
        type: "ATT",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    richtext: {
        type: "RICH TEXT",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    mod: {
        type: "MOD",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    var: {
        type: "VAR",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    txt: {
        type: "TXT",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    logical: {
        type: "LOG",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    log: {
        type: "LOG",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    sys: {
        type: "SYS",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    usr: {
        type: "USR",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    loc: {
        type: "LOC",
        noBorder: false,
        color: "var(--q-color-tag-main)",
        background: "var(--q-color-tag-background)"
    },
    // system
    overdue: {
        type: "liveView.taskDetails.OVERDUE",
        noBorder: true,
        color: "var(--q-color-error)",
        background: "var(--q-color-new-error-background)",
        width: "102px"
    },
    attention: {
        type: "liveView.taskDetails.ATTENTION",
        noBorder: true,
        color: "var(--q-color-chip-yellow-text)",
        background: "var(--q-color-chip-yellow-background)",
        width: "102px"
    },
    at_risk: {
        type: "liveView.taskDetails.AT_RISK",
        noBorder: true,
        color: "var(--q-color-chip-orange-text)",
        background: "var(--q-color-chip-orange-background)",
        width: "102px"
    },
    on_track: {
        type: "liveView.taskDetails.ON_TRACK",
        noBorder: true,
        color: "var(--q-color-chip-green-text)",
        background: "var(--q-color-chip-green-background)",
        width: "102px"
    },
    failed: {
        type: "liveView.taskDetails.FAILED",
        noBorder: true,
        color: "var(--q-color-error)",
        background: "var(--q-color-new-error-background)",
        width: "90px"
    },
    terminated: {
        type: "liveView.taskDetails.TERMINATED",
        noBorder: true,
        color: "var(--q-color-chip-black-text)",
        background: "var(--q-color-chip-black-background)",
        width: "90px"
    },
    suspended: {
        type: "liveView.taskDetails.SUSPENDED",
        noBorder: true,
        color: "var(--q-color-new-disabled)",
        background: "var(--q-color-chip-disabled-background)",
        width: "90px"
    },
    running: {
        type: "liveView.taskDetails.RUNNING",
        noBorder: true,
        color: "var(--q-color-chip-blue-text)",
        background: "var(--q-color-chip-blue-background)",
        width: "90px"
    },
    completed: {
        type: "liveView.taskDetails.COMPLETED",
        noBorder: true,
        color: "var(--q-color-chip-green-text)",
        background: "var(--q-color-chip-green-background)",
        width: "90px"
    },
    archived: {
        type: "liveView.taskDetails.ARCHIVED",
        noBorder: true,
        color: "var(--q-color-chip-blue-text)",
        background: "var(--q-color-chip-blue-background)",
        width: "90px"
    },
    system: {
        type: "system",
        noBorder: true,
        color: "var(--q-color-chip-default-text)",
        background: "var(--q-color-chip-default-background)",
        width: "78px"
    },
    external: {
        type: "external",
        noBorder: true,
        color: "var(--q-color-chip-default-text)",
        background: "var(--q-color-chip-default-background)",
        width: "78px"
    },
    platform: {
        type: "platform",
        noBorder: true,
        color: "var(--q-color-chip-default-text)",
        background: "var(--q-color-chip-default-background)",
        width: "78px"
    },
    app: {
        type: "app",
        noBorder: true,
        color: "var(--q-color-chip-default-text)",
        background: "var(--q-color-chip-default-background)",
        width: "78px"
    },
    published: {
        type: "apps.PUBLISHED",
        noBorder: true,
        color: "var(--q-color-chip-green-text)",
        background: "var(--q-color-chip-green-background)"
    },
    unpublished: {
        type: "apps.NOT_PUBLISHED",
        noBorder: true,
        color: "var(--q-color-chip-orange-text)",
        background: "var(--q-color-chip-orange-background)"
    },
    not_published: {
        type: "apps.NOT_PUBLISHED",
        noBorder: true,
        color: "var(--q-color-chip-orange-text)",
        background: "var(--q-color-chip-orange-background)"
    },
    unpublished_changes: {
        type: "apps.UNPUBLISHED_CHANGES",
        noBorder: true,
        color: "var(--q-color-chip-yellow-text)",
        background: "var(--q-color-chip-yellow-background)"
    },
    imported: {
        type: "apps.IMPORTED",
        noBorder: true,
        color: "var(--q-color-chip-black-text)",
        background: "var(--q-color-chip-black-background)"
    },
    accepted: {
        type: "userProfile.tasksDelegation.accepted",
        noBorder: true,
        color: "var(--q-color-chip-green-text)",
        background: "var(--q-color-chip-green-background)"
    },
    pending: {
        type: "userProfile.tasksDelegation.pending",
        noBorder: true,
        color: "var(--q-color-chip-orange-text)",
        background: "var(--q-color-chip-orange-background)"
    },
    rejected: {
        type: "userProfile.tasksDelegation.rejected",
        noBorder: true,
        color: "var(--q-color-error)",
        background: "var(--q-color-new-error-background)"
    },
    legacy: {
        type: "Legacy",
        noBorder: true,
        color: "var(--q-color-bright)",
        background: "var(--q-color-default-nav-icon)",
        width: "50px"
    },
    permissions: {
        type: "DSP",
        noBorder: true,
        color: "var(--q-color-secondary-text-color)",
        background: "var(--q-color-no-id-ececec)"
    },
    custom: {
        type: "CSM",
        noBorder: true,
        color: "var(--q-color-normal)",
        background: "#4285F415"
    }

};
